export const createConstantValue = (value: string): Record<string, string> => {
  if (value === null || value === undefined)
    throw new Error(
      `value of type ${typeof value} is incompatible with constant expressions`,
    );

  return {
    type: 'constant',
    value,
  };
};
